<form class="form-horizontal" autocomplete="off" #createModal="ngForm" (ngSubmit)="close()">
  <abp-modal-header [title]="'StatusPagamento' | localize" (onCloseClick)="bsModalRef.hide()"></abp-modal-header>
  <div class="modal-body">
    <div class="form-group row">
      <label class="col-md-3 col-form-label mt-2" for="numero-assinatura">
        {{ "NumeroAssinatura" | localize }}
      </label>
      <div class="col-md-9">
        <input type="text" class="form-control" name="numero-assinatura" id="numero-assinatura"
          [ngModel]="assinatura?.mercadoPagoId" disabled />
      </div>
    </div>

    <div class="form-group row">
      <label class="col-md-3 col-form-label mt-2" for="situacao">
        {{ "Situacao" | localize }}
      </label>
      <div class="col-md-9">
        <input type="text" class="form-control" name="situacao" id="situacao" [ngModel]="assinatura?.status" disabled />
      </div>
    </div>

    <div class="form-group row">
      <label class="col-md-3 col-form-label mt-2" for="valor">
        {{ "Valor" | localize }}
      </label>
      <div class="col-md-9">
        <input type="text" class="form-control" name="valor" id="valor"
          [ngModel]="assinatura?.valor | currency:'BRL':true:'1.2-2'" disabled />
      </div>
    </div>

    <div class="form-group row">
      <label class="col-md-3 col-form-label mt-2" for="data-assinatura">
        {{ "DataAssinatura" | localize }}
      </label>
      <div class="col-md-9">
        <input type="text" class="form-control" name="data-assinatura" id="data-assinatura"
          [ngModel]="assinatura?.dataAssinatura | date :'dd/MM/yyyy'" disabled />
      </div>
    </div>

    <div class="form-group row">
      <label class="col-md-3 col-form-label mt-2" for="data-vencimento">
        {{ "DataVencimento" | localize }}
      </label>
      <div class="col-md-9">
        <input type="text" class="form-control" name="data-vencimento" id="data-vencimento"
          [ngModel]="assinatura?.dataEncerramento | date :'dd/MM/yyyy'" disabled />
      </div>
    </div>

    <div class="row" *ngIf="assinatura?.qrCodeBase64">
      <div class="col-md-12">{{ "MensagemPixUm" | localize }}</div>
      <div class="col-md-12">{{ "MensagemPixDois" | localize }}</div>
      <div class="col-md-12">{{ "MensagemPixTres" | localize }}</div>

      <div class="col-md-12 text-center mt-3">
        <img style="width: 150px" [src]="'data:image/jpeg;base64,' + assinatura?.qrCodeBase64">
      </div>

      <div class="col-md-12 text-center mt-3">
        {{ assinatura?.qrCode }}
      </div>
    </div>


    <div class="row" *ngIf="assinatura?.boletoUrl">
      <div class="col-md-12">{{ "MensagemBoletoUm" | localize }}</div>

      <div class="col-md-12 text-center mt-3">
        <a [href]="assinatura?.boletoUrl" class="btn btn-outline-primary" target="_blank">
          <i class="fa fa-link"></i>
          {{ "VisualizarBoleto" | localize }}
        </a>
      </div>
    </div>


  </div>
  <abp-modal-footer [showCancel]="false" [saveLabel]="'Fechar'"></abp-modal-footer>
</form>